import { useProjectStore } from "@/stores/project-store";
import { useActivityStore } from "@/stores/activity-store";
import { useCompactSubmissionStore } from "@/stores/compact-submission-store";
import { useOnboardingStore } from "@/stores/onboarding-store";

export function recordVoiceActivity(description: string): void {
  const projectId = useProjectStore.getState().currentProject?.id;
  if (projectId) {
    useActivityStore.getState().pushEntry({
      id: `optimistic-voice-${Date.now()}`,
      description,
      dotColor: "#007AFF",
      createdAt: new Date().toISOString(),
      actorType: "user",
      projectId,
    });
  }
  useCompactSubmissionStore.getState().markPending();
  useOnboardingStore.getState().incrementMessageCount();
}
